import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Reorder } from '@mui/icons-material';

import { FormType } from '../../../../Model/Form';
import { questionFieldName as fieldName } from '../../formFields';
import { SYSTEM_FIELD_IDS } from '../../questionType';
import texts from '../../texts';

import {
  RowWrapper,
  StyledTypography,
  QuestionMetaContainer,
  FieldsContainer,
  ButtonsContainer,
  DefaultFieldIndicator,
  StyledInfoIcon,
  StyledHelpIcon,
  StatusBadge,
} from './styles';
import componentTexts from './texts.json';

const QuestionStep = ({
  question,
  removeRow,
  draggable,
  Component,
  extraProps,
  isCoachView,
  formType,
}) => {
  const unitIds = question[fieldName.UNIT_IDS] ? Object.values(question[fieldName.UNIT_IDS]) : [];
  const subFieldIds = (question[fieldName.FIELDS] || []).map((f) => f[fieldName.ID]).filter(Boolean);
  const isSystemField = SYSTEM_FIELD_IDS.includes(question[fieldName.ID])
    || unitIds.some((id) => SYSTEM_FIELD_IDS.includes(id))
    || subFieldIds.some((id) => SYSTEM_FIELD_IDS.includes(id));
  // System fields are mandatory in every native PPF, so they lock in the admin
  // FormBuilder too; lead-form system fields only lock in the coach-scoped editor.
  const disabled = isSystemField && (isCoachView || formType === FormType.POST_PAYMENT);

  return (
    <RowWrapper $isLocked={disabled} $isCoachView={isCoachView}>
      <FieldsContainer>
        <QuestionMetaContainer>
          <StyledTypography>
            {`${texts.questionTypeLabel[question[fieldName.TYPE]]}`}
          </StyledTypography>
          {disabled && (
            <StatusBadge $isLocked>
              {componentTexts.locked}
              <Tooltip title={componentTexts.lockedTooltip} placement="top">
                <StyledHelpIcon />
              </Tooltip>
            </StatusBadge>
          )}
        </QuestionMetaContainer>
        <ButtonsContainer>
          {!disabled && (
            <IconButton onClick={removeRow}>
              <Delete />
            </IconButton>
          )}
          {draggable && (
            <IconButton className="drag-handle">
              <Reorder />
            </IconButton>
          )}
        </ButtonsContainer>
      </FieldsContainer>
      {question.isDefault && (
        <DefaultFieldIndicator>
          <StyledInfoIcon />
          {componentTexts.default}
        </DefaultFieldIndicator>
      )}
      {Component && <Component {...extraProps} disabled={disabled} isCoachView={isCoachView} />}
    </RowWrapper>
  );
};

QuestionStep.propTypes = {
  question: PropTypes.object.isRequired,
  removeRow: PropTypes.func.isRequired,
  draggable: PropTypes.bool,
  Component: PropTypes.elementType,
  extraProps: PropTypes.object,
  isCoachView: PropTypes.bool,
  formType: PropTypes.string,
};

QuestionStep.defaultProps = {
  draggable: true,
  extraProps: {},
  Component: null,
  isCoachView: false,
  formType: null,
};

export default QuestionStep;
